import { Button } from '@petsmart-ui/sparky';

import { useBopisDeliveryStatus } from '../../model';

export const ShowInStockStoresButton = () => {
    const { openStoreDrawer, updateSelectedStore } = useBopisDeliveryStatus();

    const handleStoreDrawer = async () => {
        const selectedStoreId = await openStoreDrawer({
            drawerHeading: 'Pick up in store',
            toggleText: 'Only stores with item availability',
            className: 'pdp-page',
            filterFn: stores => stores.filter(store => store.attributes?.bopisEnabled),
        });
        if (selectedStoreId) {
            updateSelectedStore(selectedStoreId);
        }
    };

    return (
        <Button
            size="lg"
            fullWidth
            type="button"
            variant="primary"
            onClick={handleStoreDrawer}
            data-testid="show-in-stock-stores-button"
            text="Show in-stock stores"
        />
    );
};
